var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronClockCounter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9479_29534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.25 7.5V12L16 14.25",
    stroke: "#0A77A9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 9.75H3.25V6",
    stroke: "#0A77A9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5875 17.9999C7.76685 19.1127 9.24798 19.8533 10.8458 20.1292C12.4437 20.4051 14.0874 20.204 15.5717 19.5511C17.0559 18.8981 18.3148 17.8222 19.1911 16.4579C20.0673 15.0936 20.5221 13.5013 20.4986 11.8799C20.4751 10.2586 19.9744 8.68013 19.0589 7.34177C18.1434 6.00341 16.8539 4.9645 15.3514 4.35485C13.8488 3.74519 12.2 3.59182 10.6108 3.91391C9.02157 4.23599 7.56253 5.01925 6.41594 6.16581C5.3125 7.28331 4.40125 8.33706 3.25 9.74987",
    stroke: "#0A77A9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9479_29534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronClockCounter);
export default __webpack_public_path__ + "static/media/chevron-clock-counter.28d6945904c0dfa79f64992cc8e3ecbd.svg";
export { ForwardRef as ReactComponent };